import {Component, Input, OnInit} from '@angular/core';
import {NotificationModel} from '../../../../core-logic/models/notification/notification-model';
import {NotificationSourceList} from '../../../../common/enums/notification-source-list';
import {Router} from '@angular/router';
import {BusinessGatewayHttp} from '../../../../adapters/real/api-services/gateways/business-gateway-http';
import {getFileReader} from '../../../../common/functions/utilities-functions';
import {from} from 'rxjs';
import {NotificationManagerService} from '../../../../common/services/notification-manager.service';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent implements OnInit {
  notificationLogo = '';
  @Input() notification: NotificationModel;
  constructor(
    private router: Router,
    private businessGatewayHttp: BusinessGatewayHttp,
    private notificationManagerService: NotificationManagerService
    ) { }

  ngOnInit() {
    if (this.notification) { this.getNotificationLogo(this.notification); }
  }

  goToNotificationPath() {
    if (this.notification.path) {
      if (this.notification.path.internal && !this.notification.path.external) {
        from(this.router.navigate([this.notification.path.internal.value]))
          .subscribe(() => {
            if (this.notification.targeted.customer && this.notification.path.internal.slider_options) {
              this.notificationManagerService.setCustomerSliderOptionsSubject(this.notification);
            }
            if (this.notification.targeted.merchant && this.notification.path.internal.slider_options) {
              this.notificationManagerService.setMerchantSliderOptionsSubject(this.notification);
            }
          });
      }
      if (!this.notification.path.internal && this.notification.path.external) {
        window.location.href = this.notification.path.external;
      }
    }
  }

  getNotificationLogo(notification: NotificationModel) {
    switch (notification.source) {
      case NotificationSourceList.FYDL:
        this.notificationLogo = 'assets/icons/fydl-coral.png';
        break;
      case NotificationSourceList.BUSINESS:
        if (notification.source_id) {
          this.businessGatewayHttp.getBusinessLogoByBusinessId(notification.source_id)
            .subscribe(logoBlob => {
              const reader = getFileReader();
              reader.onloadend = () => {
                this.notificationLogo = reader.result as string;
              };
              reader.readAsDataURL(logoBlob);
            })
        }
        break;
    }
  }
}
